var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxes"},_vm._l((_vm.kpis),function(r,i){return _c('v-card',{key:i,staticClass:"card-color",attrs:{"loading":_vm.loading}},[_c('v-card-text',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(r.title)+" ")]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(r.value)+" ")])])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }